import { BulkBankTransferFileParseResult } from '../../../../../../../../../__generated__/GQL';
import { NON_BLOCKING_BULK_TRANSFERS_ERROR } from '../../../constants';
import composeErrorMessage from '../utils/composeErrorMessage';

const useComposeErrorMessages = (
  parseResult?: BulkBankTransferFileParseResult,
): { errorMessages: string[] } => {
  if (!parseResult || parseResult.errors.length === 0) {
    return { errorMessages: [] };
  }

  const { errors, totalAmount, transfers } = parseResult;

  return {
    errorMessages: errors
      .filter(({ code }) => !NON_BLOCKING_BULK_TRANSFERS_ERROR.includes(code))
      .map(({ code, transferIndexes }) =>
        composeErrorMessage({
          code,
          totalAmount,
          transferIndexes,
          transfers,
        }),
      ),
  };
};

export default useComposeErrorMessages;
